import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_ASSESSMENT} from '../../metamodel/Concept';

export default class AssessmentNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_ASSESSMENT;
	}
}
